module.exports = __webpack_public_path__ + "static/media/more.9abe8413.svg";